/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuTypeaheadContainer_viewer$ref = any;
export type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuMultiSelectSearch_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuTypeaheadContainer_viewer$ref;
    readonly " $refType": SbSharedRefineMenuMultiSelectSearch_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a7cbf25c6bfae95a04b020f702c4c3aa';
export default node;
